module.exports = require('./src/TrieSearch');